import * as Yup from 'yup';

// Constants for Article feature
export const ROUTES = {
  BASE: '/articles',
  CREATE_ARTICLE: '/articles/create',
  EDIT_ARTICLE: '/articles/edit',
  VIEW_ARTICLE: '/articles/view'
};

// Article validation schema
export const ARTICLE_SCHEMA = Yup.object().shape({
  title: Yup.string()
    .required('Title is required')
    .max(60, 'Title should be under 60 characters for better SEO'),
  byline: Yup.string()
    .required('Byline is required')
    .max(100, 'Byline should be under 100 characters'),
  introduction: Yup.string()
    .required('Introduction is required')
    .max(300, 'Introduction should be under 300 characters'),
  status: Yup.string()
    .required('Status is required'),
  tags: Yup.array()
    .of(Yup.string()
      .max(25, 'Each tag must be 25 characters or less')
      .matches(/^[a-zA-Z0-9\s-]+$/, 'Tags can only contain letters, numbers, spaces, and hyphens')
    )
    .min(1, 'At least one tag is required')
    .max(10, 'Maximum of 10 tags allowed')
});

export const ARTICLE_STATUS = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  ARCHIVED: 'Archived'
};

export const ARTICLE_FIELDS = {
  TITLE: 'title',
  CONTENT: 'content',
  STATUS: 'status',
  FEATURED_IMAGE: 'featuredImage',
  TAGS: 'tags',
  PUBLISHED_AT: 'publishedAt',
  UPDATED_AT: 'updatedAt'
};


export const TEMPLATES = [
  // {
  //   id: 'GENERAL',
  //   name: 'Standard Article',
  //   description: 'A standard article with a title, content, and featured image',
  //   icon: 'pi pi-file',
  //   component: null // Using default form for now
  // },
  {
    id: 'GALLERY',
    name: 'Gallery',
    description: 'An article with an image gallery',
    icon: 'pi pi-images',
    component: 'GalleryArticleForm'
  },
  // {
  //   id: 'VIDEO',
  //   name: 'Video',
  //   description: 'An article with an embedded video',
  //   icon: 'pi pi-video',
  //   component: null
  // },
  // {
  //   id: 'PRODUCT',
  //   name: 'Product',
  //   description: 'A product showcase article',
  //   icon: 'pi pi-shopping-bag',
  //   component: null
  // }
];
